/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Dashboard_TitleInputs */

const vi_warehouse_sales_dashboard_title = /** @type {(inputs: Warehouse_Sales_Dashboard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan Kho hàng bán`)
};

/**

* @param {Warehouse_Sales_Dashboard_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_dashboard_title = /** @type {((inputs?: Warehouse_Sales_Dashboard_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Dashboard_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_dashboard_title(inputs)
});